<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="os-tabs-w" v-if="current.id">
              <div class="os-tabs-controls os-tabs-complex text-right">
                <ul class="nav nav-tabs">
                  <li class="nav-item">
                    <span aria-expanded="true" class="nav-link active">
                      <span class="tab-label" v-if="
                        current.observacion != 'DEVOLUCION DESDE RECEPCION'
                      " style="font-size: small;">Total Devuelto</span>
                      <span class="tab-value" v-if="
                        current.observacion != 'DEVOLUCION DESDE RECEPCION'
                      ">Q {{ current.valor_total_devuelto }}</span>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="element-box">
              <router-link class="btn btn-outline-info" :to="{ name: 'wms-devolucion-provedor' }">
                <i class="fa fa-arrow-left"></i>
                Regresar
              </router-link>
              <form @submit="guardar">
                <h5 class="form-header">
                  Devolución a Proveedor #
                  <u>{{ current.numero }}</u>
                  &nbsp;
                  <div class="badge" :class="{
                    'badge-success': current.estado == 'A',
                    'badge-warning': current.estado == 'B',
                    'badge-danger': current.estado == '9',
                  }">
                    <i class="os-icon os-icon-ui-09"></i>
                    <span v-if="current.estado_str">{{
                      current.estado_str
                    }}</span>
                    <span v-if="!current.estado_str">En Proceso</span>
                  </div>
                  <br /><br />
                  <div class="st-meta float-right">
                    <div class="element-actions">
                      <button :disabled="current.estado == 'A'" class="btn btn-outline-dark" @click="imprimir">
                        <i class="fa fa-print"></i>
                        Imprimir
                      </button>
                      &nbsp;

                      <!-- Botón Vale de Devolución: Ver si ya existe, Subir si no -->
                      <a
                        v-if="current.archivo_url"
                        :href="current.archivo_url"
                        target="_blank"
                        class="btn btn-outline-danger"
                      >
                        <i class="fas fa-file-pdf mr-1"></i>
                        Ver Archivo
                      </a>
                      <button
                        v-else
                        type="button"
                        class="btn btn-outline-danger"
                        data-toggle="modal"
                        data-target="#modalSubirValeDevolucion"
                      >
                        <i class="fas fa-file-upload mr-1"></i>
                        Subir Vale
                      </button>
                      &nbsp;

                      <div class="btn-group">
                        <button aria-expanded="false" aria-haspopup="true" class="btn btn-secondary dropdown-toggle"
                          data-toggle="dropdown" type="button">
                          <i class="fa fa-cogs"></i>
                          Acciones
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                          <button class="dropdown-item" :class="{ disabled: !(current.estado == 'B') }" @click="abrir"
                            :disabled="!(current.estado == 'B')" href="#">
                            <i class="fa fa-unlock"></i>
                            Abrir Operación
                          </button>
                          <button class="dropdown-item" @click="cerrar" :disabled="!(current.estado == 'A')" href="#">
                            <i class="fa fa-lock"></i>
                            Cerrar Operación
                          </button>
                          <button class="dropdown-item" @click="anular" :disabled="!(current.estado != '9')" href="#">
                            <i class="fa fa-archive"></i>
                            Anular Operación
                          </button>
                          <div v-if="current.archivo_url" class="dropdown-divider"></div>
                          <button
                            v-if="current.archivo_url"
                            class="dropdown-item"
                            type="button"
                            data-toggle="modal"
                            data-target="#modalSubirValeDevolucion"
                          >
                            <i class="fas fa-retweet mr-1"></i>
                            Reemplazar Vale
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                </h5>
                <small v-if="current.errors && current.errors.detail" class="form-text text-danger">{{
                  current.errors.detail }}</small>
                <div class="row col-12">
                  <div class="col-12">
                    <div class="form-group">
                      <label v-bind:class="{
                        'text-danger':
                          current.errors.tienda &&
                          current.errors.tienda.length > 0,
                      }">Tienda</label>
                      <select class="form-control" autofocus="autofocus" v-model="current.tienda" :disabled="true">
                        <option v-for="(tienda, key) in tiendas" :value="tienda.codigo" :key="key">
                          {{ tienda.nombre }}
                        </option>
                      </select>
                      <small v-if="current.errors && current.errors.tienda" class="form-text text-danger">{{
                        current.errors.tienda[0] }}</small>
                    </div>
                  </div>
                  <div class="col col-sm-6">
                    <ProveedoresSelectComponent :current="current" :disabled="true" />
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Referencia</label>
                      <input v-model="current.referencia" autofocus="autofocus" class="form-control"
                        placeholder="Referencia" type="text" :disabled="true" />
                      <small v-if="current.errors && current.errors.referencia" class="form-text text-danger">{{
                        current.errors.referencia[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label v-bind:class="{
                        'text-danger':
                          current.errors.fecha &&
                          current.errors.fecha.length > 0,
                      }">Fecha</label>
                      <input v-model="current.fecha" class="form-control" placeholder="Fecha" :disabled="true"
                        type="text" />
                      <small v-if="current.errors && current.errors.fecha" class="form-text text-danger">{{
                        current.errors.fecha[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Usuario</label>
                      <input :disabled="true" class="form-control" v-model="current.usuario" type="text" />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Motivo de Devolución</label>
                      <input v-model="current.observacion" autofocus="autofocus" class="form-control"
                        placeholder="Motivo de Devolución" type="text" :disabled="true" />
                      <small v-if="current.errors && current.errors.observacion" class="form-text text-danger">{{
                        current.errors.observacion[0] }}</small>
                    </div>
                  </div>
                </div>
                <button type="button" class="btn btn-sm btn-secondary btn-block" @click="showModalAddDetail"
                  v-if="current.estado == 'A'">
                  <i class="fa fa-plus"></i>
                  Agregar Producto
                </button>
                <br />
                <div class="projects-list">
                  <div class="project-box" v-for="detalle in current.devolucionproveedord_set" v-bind:key="detalle.id">
                    <div style="cursor: pointer; background-color: #ebffdb">
                      <div class="project-head">
                        <div class="project-title">
                          <h5>{{ detalle.producto.sku }}</h5>
                          {{ detalle.producto.nombre }}
                          <br />
                          <small>{{ detalle.posicion.descripcion }}</small>
                          <br />
                          <small>{{ detalle.unidad_medida.nombre }}</small>
                          <br />
                        </div>
                      </div>
                      <div class="project-info">
                        <div class="row align-items-center">
                          <div class="col-12">
                            <div class="row">
                              <div class="col-4">
                                <div class="el-tablo highlight text-center">
                                  <div class="label">Cantidad</div>
                                  <div class="col-12">
                                    <h6 style="color: #0068ff">
                                      {{ detalle.cantidad }}
                                    </h6>
                                  </div>
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="row">
                                  <div class="col-12">
                                    <div class="el-tablo highlight text-center">
                                      <div class="label">Costo</div>
                                      <div class="value">
                                        <h6 style="color: #0068ff">
                                          {{ detalle.costo }}
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="row">
                                  <div class="col-12">
                                    <div class="el-tablo highlight text-center">
                                      <div class="label">Total</div>
                                      <div class="value">
                                        <h6 style="color: #0068ff">
                                          {{ detalle.valor_total }}
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="col-12">
                              <div class="row">
                                <div class="col-12">
                                  <div class="el-tablo highlight text-center">
                                    <div>
                                      <button class="btn btn-sm btn-danger btn-block" type="button"
                                        v-if="current.estado == 'A'" @click="eliminarDetalle(detalle)">
                                        <i class="fa fa-trash"></i>
                                        Eliminar
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-buttons-w">
                  <!-- <button
                    class="btn btn-sm btn-success btn-block"
                    v-if="current.estado == 'A'"
                    type="submit"
                  >
                    Guardar
                  </button> -->
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div aria-hidden="true" class="modal fade" id="modalAddDetailReqTraslado" role="dialog" tabindex="-1">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Agregar Producto</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <h6 style="color: blue" v-if="currentDetalle && currentDetalle.producto">
                  {{ currentDetalle.producto.sku }}
                  {{ currentDetalle.producto.nombre }}
                </h6>
                <div class="col-sm-12 mb-1">
                  <div class="form-group">
                    <label for>Producto</label>
                    <input v-on:keyup.enter="refreshProducto(barra)" class="form-control" placeholder="Producto"
                      type="text" autocomplete="off" v-model="barra" @input="resetDataProducto" />
                    <small class="form-text text-danger" v-if="errors">{{
                      errors.producto_barra
                    }}</small>
                    <small v-if="
                      currentDetalle.errors && currentDetalle.errors.producto
                    " class="form-text text-danger">{{ currentDetalle.errors.producto }}</small>
                  </div>
                  <div class="col-sm-12">
                    <button @click="refreshProducto(barra)" type="button" class="btn btn-sm btn-info btn-block">
                      Buscar
                    </button>
                    &nbsp;
                  </div>
                </div>
                <div class="col-sm-12 mb-1">
                  Lotes:
                  <select v-model="currentDetalle.codigo_lote" v-if="
                    currentDetalle.producto.productolote_set != null &&
                    currentDetalle.producto.productolote_set.length > 0
                  " class="form-control" autofocus="autofocus">
                    <option v-for="detalle in currentDetalle.producto
                      .productolote_set" :value="detalle.id" v-bind:key="detalle.id">
                      Lote: {{ detalle.codigo_lote }} || Vence:
                      {{ detalle.fecha_vence }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-12">
                  Posicion:
                  <select v-model="currentDetalle.posicion" class="form-control">
                    <option v-for="detalle in posiciones" :value="detalle.posicion_id" v-bind:key="detalle.id">
                      {{ detalle.codigo_barra }}
                    </option>
                  </select>
                  <small v-if="
                    currentDetalle.errors && currentDetalle.errors.posicion
                  " class="form-text text-danger">{{ currentDetalle.errors.posicion[0] }}</small>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        currentDetalle.errors &&
                        currentDetalle.errors.cantidad_um,
                    }">Cantidad</label>
                    <input v-model="currentDetalle.cantidad_um" class="form-control" placeholder="Cantidad" type="text"
                      style="text-align: center; font-size: 200%" v-bind:class="{
                        'is-invalid':
                          currentDetalle.errors.cantidad_um &&
                          currentDetalle.errors.cantidad_um.length > 0,
                      }" />
                    <small v-if="
                      currentDetalle.errors &&
                      currentDetalle.errors.cantidad_um
                    " class="form-text text-danger">{{ currentDetalle.errors.cantidad_um }}</small>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="agregaDetalle" type="button">
              Agregar
            </button>
            <button class="btn btn-secondary" ref="cerrarModal" data-dismiss="modal" type="button">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal: Subir Vale de Devolución PDF -->
    <SubirValeDevolucionModal :current="current" @uploaded="refreshCurrent" />
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import CommonService from "@/services/commons/CommonService";
import ProductosService from "@/services/catalogos/ProductosService";
import PosicionesService from "@/services/inventario/PosicionesService";
import DynamicService from "@/services/commons/DynamicService";
import DevolucionesProveedoresService from "@/services/inventario/DevolucionesProveedoresService";
import Notifications from "@/notifications/notifications";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import UnidadMedidaSelectComponent from "@/components/commons/UnidadMedidaSelectComponent";
import SubirValeDevolucionModal from "./SubirValeDevolucionModal";
import { notificarError } from '@/utils'


export default {
  components: {
    ProveedoresSelectComponent,
    UnidadMedidaSelectComponent,
    SubirValeDevolucionModal,
  },
  data() {
    return {
      barra: "",
      errors: "",
      current: {
        errors: "",
        id: null,
        estado_str: null,
        tienda: "",
        fecha: "01/01/2019",
        estado: "A",
        errors: [],
      },
      unidad_medida_default: "",
      productos: [],
      posiciones: [],
      options: [],
      producto_lote: [],

      bodegas: [],
      secciones: [],
      racks: [],
      niveles: [],

      busqueda_posicion: {
        bodega_id: null,
        seccion_id: null,
        rack_id: null,
        posicion_id: null,
      },
      currentDetalle: {
        cantidad: 0,
        costo: 0,
        posicion: 0,
        producto: "",
        codigo_lote: 0,
        productolote_set: [],
        errors: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
    fecha_str: function () {
      let self = this;
      return self.customFormatter(self.current.fecha);
    },
  },
  mounted() {
    let self = this;
    CommonService.fecha_actual().then((res) => {
      self.current.fecha = res.data.fecha_actual;
    });
    this.$store.dispatch("catalogos/llenar_tiendas", {
      activa: true,
      quitar_paginacion: true,
    });
    if (this.$route.params.id) {
      self.refreshCurrent();
      self.refreshUnidadeMedida();
    }
    DynamicService.fetch("cat", "unidad-medida", {
      cantidad_unidades: 1,
    }).then((res) => {
      self.currentDetalle.unidad_medida = res.data.results[0].id;
    });
  },
  methods: {
    refreshProducto(barra) {
      let self = this;
      if (!barra) {
        self.errors.producto = "Este campo no puede ser nulo";
        return;
      }
      DynamicService.fetch("cat", "producto-barra", {
        barra: barra,
        activo: true,
      })
        .then((response) => {
          self.currentDetalle.producto = response.data.results[0].producto_obj;
          self.errors.producto = "";
          if (self.currentDetalle.producto) {
            self.buscarIdProducto();
          }
        })
        .catch((err) => {
          self.producto = null;
          self.errors.producto = "No existe producto";
        });
    },
    buscarIdProducto() {
      let self = this;
      DynamicService.getById(
        "cat",
        "productos",
        self.currentDetalle.producto.sku
      ).then((response) => {
        self.currentDetalle.producto = response.data;
      });
    },
    formatoFecha() {
      let self = this;
      self.current.fecha = self.current.fecha.replace(/\//g, "-");
    },
    setSelected(value) {
      let self = this;
      ProductosService.getById(value.sku).then((res) => {
        self.currentDetalle.productolote_set = res.data.productolote_set;
        self.currentDetalle.productounidadmedida_set =
          res.data.productounidadmedida_set;
        self.currentDetalle.codigo_lote = res.data.productolote_set[0].id;
      });
    },
    refreshCurrent() {
      let self = this;
      DevolucionesProveedoresService.getById(this.$route.params.id).then(
        (response) => {
          self.current = response.data;
          self.current.usuario = response.data.usuario.name;
          self.current.tienda = response.data.tienda;
          self.current.fecha = self.customFormatter(self.current.fecha);
          self.current.errors = [];
          self.currentDetalle.errors = [];
          self.currentDetalle.cantidad = 0;
        }
      );
    },
    refreshBodegas() {
      let self = this;
      DynamicService.fetch("cat", "tienda-bodega", {
        tienda: self.current.tienda,
        quitar_paginacion: true,
      }).then((res) => {
        self.bodegas = res.data;
      });
    },
    changeBodega() {
      this.refreshSecciones();
    },
    changeSeccion() {
      this.refreshRacks();
    },
    changeRack() {
      this.refreshNiveles();
    },
    changeNivel() {
      this.refreshPosiciones();
    },
    refreshSecciones() {
      let self = this;
      DynamicService.fetch("cat", "tienda-seccion", {
        tienda: self.current.tienda,
        bodega: self.busqueda_posicion.bodega_id,
        quitar_paginacion: true,
      }).then((res) => {
        self.secciones = res.data;
      });
    },
    refreshPosiciones() {
      let self = this;
      let params = {
        page: 1,
        tienda: self.current.tienda,
        quitar_paginacion: true,
      };
      if (self.busqueda_posicion.bodega_id) {
        params.bodega_id = self.busqueda_posicion.bodega_id;
      }
      if (self.busqueda_posicion.seccion_id) {
        params.seccion_id = self.busqueda_posicion.seccion_id;
      }
      if (self.busqueda_posicion.rack_id) {
        params.rack_id = self.busqueda_posicion.rack_id;
      }
      if (self.busqueda_posicion.nivel_id) {
        params.nivel_id = self.busqueda_posicion.nivel_id;
      }

      PosicionesService.fetch(params).then((res) => {
        self.posiciones = res.data;
      });
    },
    refreshSecciones() {
      let self = this;
      DynamicService.fetch("cat", "tienda-seccion", {
        tienda: self.current.tienda,
        bodega: self.busqueda_posicion.bodega_id,
        quitar_paginacion: true,
      }).then((res) => {
        self.secciones = res.data;
      });
    },
    refreshRacks() {
      let self = this;
      DynamicService.fetch("cat", "tienda-rack", {
        tienda: self.current.tienda,
        seccion: self.busqueda_posicion.seccion_id,
        quitar_paginacion: true,
      }).then((res) => {
        self.racks = res.data;
      });
    },
    refreshNiveles() {
      let self = this;
      DynamicService.fetch("cat", "tienda-nivel", {
        tienda: self.current.tienda,
        rack: self.busqueda_posicion.rack_id,
        quitar_paginacion: true,
      }).then((res) => {
        self.niveles = res.data;
      });
    },
    resetDataProducto() {
      this.currentDetalle.producto = [];
      this.errors = [];
    },
    guardar(e) {
      e.preventDefault();
      let self = this;
      let current = Object.assign({}, self.current);
      current.tienda = self.current.tienda;
      if (self.current.proveedor) {
        current.proveedor = self.current.proveedor.codigo;
      }
      DevolucionesProveedoresService.save(current)
        .then((response) => {
          if (current.id == null) {
            self.$router.push({
              name: "inventario-devoluciones_proveedor-editar",
              params: { id: response.data.id },
            });
            self.refreshCurrent();
          }
        })
        .catch((error) => {
          self.current.errors = error.response.data;
        });
    },
    onSearchPosicion(search, loading) {
      loading(true);
      this.searchPosicion(loading, search, this);
    },

    searchPosicion: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);

        return;
      }
      let self = this;
      let params = {
        page: 1,
        tienda: vm.current.tienda,
        quitar_paginacion: true,
        "filter[search]": search,
      };
      if (self.busqueda_posicion.bodega_id) {
        params.bodega_id = self.busqueda_posicion.bodega_id;
      }
      if (self.busqueda_posicion.seccion_id) {
        params.seccion_id = self.busqueda_posicion.seccion_id;
      }
      if (self.busqueda_posicion.rack_id) {
        params.rack_id = self.busqueda_posicion.rack_id;
      }
      if (self.busqueda_posicion.nivel_id) {
        params.nivel_id = self.busqueda_posicion.nivel_id;
      }

      PosicionesService.fetch(params).then((res) => {
        vm.posiciones = res.data;
        loading(false);
      });
    }, 350),

    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },

    onSearchProducto(search, loading) {
      loading(true);
      this.searchProducto(loading, search, this);
    },

    searchProducto: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      ProductosService.fetch({
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.productos = res.data;
        loading(false);
      });
    }, 350),

    customFormatter(date) {
      var d = date.toString().split("/");
      var str_d = d[2] + "-" + d[1] + "-" + d[0];

      return moment(str_d).format("DD/MM/YYYY");
    },
    showModalAddDetail() {
      let self = this;
      PosicionesService.fetch({
        page: 1,
        tienda: self.current.tienda,
        activo: true,
      }).then((res) => {
        self.posiciones = res.data.results;
      });
      $("#modalAddDetailReqTraslado").modal();
    },
    refreshUnidadeMedida() {
      let self = this;
      DynamicService.fetch("cat", "unidad-medida", {
        cantidad_unidades: 1,
      }).then((response) => {
        self.unidad_medida_default = response.data.results[0];
      });
    },
    agregaDetalle() {
      let self = this;
      self.currentDetalle.unidad_medida = self.unidad_medida_default.id;
      let det = Object.assign({}, self.currentDetalle);
      if (det.producto) {
        det.producto = det.producto.sku;
      }
      if (det.codigo_lote) {
        det.producto_lote = det.codigo_lote;
      }
      DevolucionesProveedoresService.agregar_detalle(self.current.id, det)
        .then((response) => {
          Notifications.alert.success(
            "Devoluciones de Proveedores",
            "Se ha guardado la Información."
          );
          self.refreshCurrent();
          self.refreshDetalleDefault();
          self.$refs.cerrarModal.click();
        })
        .catch((error) => {
          notificarError(this.$toast,error.response.data);
          // Notifications.alert.error(
          //   "Crear Devolución",
          //   error.response.data.detail
          // );
          console.log(error.response.data);
          self.currentDetalle.errors = error.response.data;
        });
    },

    eliminarDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Devolución de proveedores",
        "¿Esta seguro de eliminar el registro?",
        "Si Eliminar",
        function () {
          DevolucionesProveedoresService.eliminar_detalle(self.current.id, {
            id: detalle.id,
          })
            .then((response) => {
              Notifications.alert.success(
                "Devolución de Proveedores",
                "Se ha eliminado la Información."
              );
              self.refreshCurrent();
            })
            .catch((errors) => {
              self.current.errors = error.response.data;
            });
        }
      );
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Devolucion de Proveedores",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          DevolucionesProveedoresService.abrir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Devolución de Proveedores",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Abrir Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Devolucion de Proveedores",
        "Desea cerrar la transacción?",
        "Si Abrir",
        function () {
          DevolucionesProveedoresService.cerrar(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Devolución de Proveedores",
                "Se ha cerrado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Cerrar Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Devolución de Proveedores",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          DevolucionesProveedoresService.anular(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Devolución de Proveedores",
                "Se ha anulado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Anular Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    refreshDetalleDefault() {
      let self = this;
      self.currentDetalle = {
        cantidad: 0,
        cantidad_um: 0,
        unidad_medida: null,
        producto: {},
        errors: [],
      };
      self.barra = "";
    },
    imprimir() {
      let self = this;
      let id = self.current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=inventario/devolucion_proveedor/enc_devolucion_proveedor.jrxml&id=${id}`
      );
    },
  },
};
</script>
